import { store } from '../store/index';
import { saveCropSelectionDetails, croppingSelectedImage } from "../actions/wizard";
export function constructTemplate(type: string){
    try {
        const pageType = type.toLowerCase();
        switch (pageType) {
            case "plan":
                 return {
                    
                 }
            case "elevation dimension":
                return {

                }
            case "elevation material":
                return {

                }   
            case 'elevation internals':
                return {

                }   
            case 'appliances': 
                return{

                }
            case 'custom': 
                return {

                }                
            default:
                break;
        }
    } catch (error) {
        console.error("Error in constructTemplate",error);
    }
}

export const debounce= function(callback, d) {
    let timer;
    return function (data) {
        clearTimeout(timer)
        timer = setTimeout(()=>{
            callback(data)
        },d);
    }
}

export const addPDFLinks = (pageIndexes:Array<number>,set, pdfLinks)=>{
    if(pageIndexes && pageIndexes.length){
        pageIndexes.map(pageIn=>{
            set.add(pdfLinks[pageIn-1])
            return pageIn;
        })
   }
}

export const addPageNotes = (additionalNotes:string,pageData,checkText:string) => {
    pageData["notes"] = pageData["notes"] && pageData["notes"].includes(checkText)?pageData["notes"]:`${additionalNotes} ${pageData["notes"] || ""}`;
}

export const mergePageData = (oldPage, newPage) => {
    const merged = { ...oldPage };
    Object.keys(newPage).forEach(key => {
        if ((key === 'drawing' || key === 'metaData') && oldPage[key] !== undefined && oldPage[key] !== null) {
            return;
        }
        if (newPage[key] !== undefined && newPage[key] !== null) {
            merged[key] = newPage[key];
        }
    });
    return merged;
}

export const saveCropImageDetails = (data) => {
    store.dispatch(saveCropSelectionDetails(data));
    var escapeEvent = new KeyboardEvent('keydown', {
        key: 'Escape',
        code: 'Escape',
        bubbles: true,
        cancelable: true
    });

    // Dispatch the event
    document.dispatchEvent(escapeEvent);
}

export const cropSelectedImage = () => {
    store.dispatch(croppingSelectedImage());
}